import React from 'react'

function ConditionsForContributorsFR() {
  return (
    <>
      <p className="heading-1">
        Conditions Générales d’Utilisation (CGU) Skeepers Influence
      </p>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">1. Objet</p>
        <p>
          Les présentes conditions générales d’utilisation (les « CGU ») ont
          pour vocation de régir l’utilisation du site{' '}
          <a
            href="http://app.im.skeepers.io/"
            target="_blank"
            rel="noopener noreferrer"
          >
            http://app.im.skeepers.io/
          </a>{' '}
          édité par la société Skeepers ainsi que les termes et conditions dans
          lesquelles les différents services proposés sur ce site sont fournis.
          La navigation sur le Site tel que défini ci-après emporte de plein
          droit acceptation expresse et sans réserve par le Creator des
          présentes CGU.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">2. Définitions</p>
        <p>
          Les termes ci-après employés avec une majuscule ont la définition qui
          leur est attribuée ci-dessous :
        </p>
        <div className="definition">
          <p>CGU</p>
          <p>Désigne les présentes conditions générales d’utilisation ;</p>
        </div>
        <div className="definition">
          <p>Client</p>
          <p>
            Désigne la société, le fabricant ou l’entité commercialisant le
            produit/service sous une marque, objet du Contenu ;
          </p>
        </div>
        <div className="definition">
          <p>Contenu</p>
          <p>
            Désigne les textes, images, photographies, dessins, avatars, et plus
            généralement toute publication visuelle, textuelle, sonore ou
            graphique du Creator, représentant les Produits, diffusés dans le
            cadre des Services ;
          </p>
        </div>
        <div className="definition">
          <p>Creator</p>
          <p>
            Personne préalablement enregistrée et accédant à la plateforme
            Skeepers dans le but de générer des Contenus. (IM et CV) ;
          </p>
        </div>
        <div className="definition">
          <p>Identifiants</p>
          <p>
            Désigne le nom d’Creator et le mot de passe permettant au Creator
            d’accéder au Site ;
          </p>
        </div>
        <div className="definition">
          <p>Influenceur</p>
          <p>
            Creator ayant reçu un produit gratuitement afin qu’il poste un
            Contenu dédié sur son réseau social (ex : Instagram, TikTok,
            YouTube, Pinterest, Blog…) ;
          </p>
        </div>
        <div className="definition">
          <p>Produits</p>
          <p>Désigne les produits et services commercialisés par le Client ;</p>
        </div>
        <div className="definition">
          <p>Profil</p>
          <p>Désigne l’interface sur le Site dédiée au Creator ;</p>
        </div>
        <div className="definition">
          <p>Réseaux Sociaux</p>
          <p>
            Désignent tous les réseaux sociaux présents ou à venir dont les
            Contenus peuvent faire l’objet des Services de Skeepers, tels que, à
            titre d’exemple : YouTube, Instagram, Facebook, Twitter, Twitch,
            Blogs, TikTok, Pinterest.
          </p>
        </div>
        <div className="definition">
          <p>Site</p>
          <p>
            Désigne le site internet accessible à l’adresse{' '}
            <a
              href="http://app.im.skeepers.io/"
              target="_blank"
              rel="noopener noreferrer"
            >
              http://app.im.skeepers.io/
            </a>{' '}
            ;
          </p>
        </div>
        <div className="definition">
          <p>Services</p>
          <p>Désigne les services fournis par Skeepers ;</p>
        </div>
        <div className="definition">
          <p>Skeepers</p>
          <p>
            Désigne l’entité juridique identifiée dans les Mentions Légales du
            Site ;
          </p>
        </div>
        <div className="definition">
          <p>Tester</p>
          <p>
            Creator ayant reçu un produit gratuitement afin qu’il génère un avis
            vidéo (CV) ou textuel (IM), qui sera diffusé sur le site e-commerce
            du Client et/ou de ses partenaires.
          </p>
        </div>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">3. Description des Services</p>
        <p>Skeepers propose aux Creators les Services suivants :</p>
        <ul className="paragraph-2">
          <li>
            L’accès au Site par les Creators (incluant la visualisation des
            statistiques, les échanges et le matching avec les Produits et les
            Clients) ;
          </li>
          <li>L’envoi de Produits et/ou d’avantages y afférents.</li>
        </ul>
        <p>
          Les services offerts par Skeepers sont proposés aux Creators à titre
          gratuit.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">4. Accès aux Services</p>
        <p>
          Skeepers ne garantit aucunement que le Site soit accessible en
          continu. Skeepers se réserve le droit de modifier, suspendre et/ou
          supprimer tout ou partie du Site et des informations qu'ils
          contiennent à tout moment et ce, sans préavis. Par conséquent,
          Skeepers ne saurait être tenue pour responsable de tout dommage avéré
          ou allégué, subi directement ou indirectement, par tout Creator, lié à
          la connexion, la consultation et/ou l'utilisation des informations
          fournies par le Site.
        </p>
        <p>
          Pour accéder au Services les Creators doivent se connecter au Site
          avec leur Identifiants dans les conditions ci-après décrites.
        </p>
        <p>
          De manière générale, tout manquement aux stipulations des présentes
          CGU, pourra entrainer, immédiatement et sans information préalable, la
          suppression ou suspension du compte de le Creator, nonobstant toute
          demande de dommages et intérêts de Skeepers.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">5. Compte personnel Skeepers</p>
        <p className="tc-neutral900 ml-16">1/ L’Inscription</p>
        <p>
          L’inscription sur le Site pour se créer un compte personnel s’effectue
          via l’interface dédiée aux Creators sur le Site, en remplissant toutes
          les informations identifiées comme étant obligatoires. Le Creator peut
          également renseigner des informations facultatives, telles que, sans
          que cette liste soit exhaustive : ses marques préférées, ses centres
          d’intérêt, etc.
        </p>
        <p>
          Skeepers se réserve le droit de refuser toute inscription incomplète
          ou non conforme.
        </p>
        <p>Le Creator garantit à Skeepers que :</p>
        <ul className="paragraph-2">
          <li>
            Le Creator est âgé d’au moins seize (16) ans. S’il n’a pas atteint
            la majorité dans son pays de résidence, il devra obtenir l’accord
            parental pour se créer un compte personnel sur le Site ;
          </li>
          <li>
            Le Creator n’est pas un ancien ou actuel salarié de Skeepers ni ne
            travaille pour une agence media ou une agence publicitaire
            partenaire de Skeepers.
          </li>
        </ul>
        <p>
          En qualité d’Influenceur, le Creator doit avoir au minimum un compte
          sur un Réseau Social qui est disponible en mode public et qui
          comptabilise un nombre minimum de followers (celui-ci est précisé pour
          chaque Réseau Social concerné sur le Site après l’inscription) ; et ce
          pendant toute la durée de son inscription sur le Site.
        </p>
        <p>
          Skeepers se réserve le droit, à tout moment et pendant toute la durée
          de l’inscription, de vérifier que le Compte Réseau Social de
          l’Influenceur remplit bien les critères mentionnés ci-dessus. Dans
          l'hypothèse où le Compte Réseau Social ne remplirait plus un des
          critères mentionnés ci-dessus, Skeepers se réserve le droit de
          désactiver et/ou résilier le compte personnel de le Creator sur le
          Site.
        </p>
        <p>
          Le Creator s’engage à ne pas accroître artificiellement de manière
          automatique et/ou manuelle, lui-même par l'intermédiaire d'un tiers,
          le nombre de vues, d'impressions et/ou de clics associés aux Contenus
          qu’il publie sur son Compte Réseau Social, ni à inciter d'autres
          personnes à le faire.
        </p>
        <p>
          Le Creator garantit que les informations renseignées pour la création
          de son compte sont exactes, sincères et personnelles. Le Creator
          s’engage à mettre à jour régulièrement ses informations afin
          d’informer Skeepers sur son profil personnel et de bénéficier des
          Services les plus adaptés mis à disposition par Skeepers. Skeepers se
          réserve la possibilité d’effacer tout compte dont, en particulier, les
          informations sont incorrectes ou dont l’adresse, notamment postales,
          ne permettraient pas l’envoi et l’utilisation normale des Produits.
          L’inscription de le Creator entraine automatiquement la création d’un
          compte et d’un profil au nom du pseudo qu’il utilise sur les réseaux
          sociaux, ainsi qu’un espace d’informations relatives au Creator
          accessibles notamment aux Clients en cas de matching.
        </p>

        <p className="tc-neutral900 ml-16">2/ Le Compte Personnel</p>
        <p>
          Après l’inscription sur le Site telle que décrite ci-dessus, le
          Creator finalise la création de son compte en renseignant des
          Identifiants, lesquels sont susceptibles d’être modifiés par le
          Creator, sur son compte. Le compte est accessible dans les mêmes
          conditions que Site. Les Identifiants sont personnels et ne peuvent,
          sous peine de voir le compte suspendu ou supprimé, être communiqués ou
          exploités par un tiers. Toute suspicion d'une divulgation,
          intentionnelle ou non, des identifiants et mots de passe engage la
          responsabilité unique et personnelle de le Creator. En aucun cas
          Skeepers ne saurait être responsable pour toute utilisation illicite
          ou frauduleuse des identifiants et mots de passe ainsi que des
          différents outils mis à la disposition de le Creator.
        </p>
        <p>
          Le Creator peut également visualiser sur son compte ses crédits, les
          Produits commandés, en cours, les Contenus en cours et précédents.
        </p>
        <p>
          La création d’un compte personnel ne donne pas droit au Creator
          automatiquement au bénéfice de tous les Services et ne garantit pas le
          « matching » avec des Produits, Skeepers se réservant le choix des
          Testeurs bénéficiaires des Produits, et le Client celui des
          Influenceurs bénéficiaires des Produits.
        </p>
        <p>
          Le Creator peut demander à Skeepers la résiliation de son compte à
          tout moment moyennant le respect d'un préavis écrit (email étant
          suffisant) de quinze (15) jours envoyé à Skeepers.
        </p>

        <p className="tc-neutral900 ml-16">3/ Le Profil</p>
        <p>
          La création du compte Skeepers sur le Site génère la création d’un
          Profil permettant d’identifier le Creator et de lui faire bénéficier
          des Services. Dès la création du Profil personnel, le Creator est
          identifié sur le Site par le pseudonyme et l’avatar qu’il utilise sur
          le(s) réseau(x) social(/aux) renseigné par le Creator sur le Site. Le
          Profil contient également les Contenus précédents automatiquement
          téléchargés sur le Site, ce à quoi le Creator consent.
        </p>
        <p>
          Selon les informations fournies par le Creator lors de son
          inscription, son Profil est susceptible de correspondre à des
          Produits. Dans une telle éventualité, le matching entre le Creator et
          les Produits est alors possible. Toutefois, Skeepers se réserve le
          droit de limiter ce matching selon ses propres critères de sélection.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">6. Utilisation des Services</p>
        <p className="tc-neutral900 ml-16">
          1/ Commandes de Produits et publication de Contenus
        </p>
        <p>
          Sur son compte, le Creator peut visualiser les Produits proposés par
          les Clients susceptibles de « matcher » avec son Profil. Les
          informations relatives au prix des Produits et les conditions à
          respecter pour diffuser du Contenu s’y référant (par exemple, sans que
          cette liste soit exhaustive : mentionner le Client, ajouter un
          hashtag, …) sont également précisées par le Client lors de la
          description des Produits.
        </p>
        <p>
          Si une offre plait au Creator, il peut sélectionner l’onglet «
          Commander » pour recevoir le Produit. Avant de confirmer la commande,
          il doit cocher une case pour préciser qu’il a bien pris connaissance
          des conditions relatives au Contenu qu’il devra publier.
        </p>
        <p>
          Après avoir confirmé la commande, le Creator reçoit le Produit sans
          frais (soit directement du Client ou de Skeepers).
        </p>
        <p>
          Une fois que le Produit a été reçu et testé, le Creator crée un
          Contenu tout en respectant les conditions fixées par le Client dans la
          description du Produit, qu’il a acceptées.
        </p>
        <p>
          L’Influenceur partage le lien de son Contenu sur le Site dans un délai
          d'une heure suivant la publication de son Contenu sur ses Réseaux
          Sociaux. Le Contenu devra être publié en « mode public » et devra
          rester accessible pour au moins trente (30) jours à compter de sa
          publication sur ses Réseaux Sociaux sauf en cas de changement d’avis
          concernant le Produit lequel devra préalablement être notifié par
          email à Skeepers.
        </p>
        <p>
          Le Creator coche ensuite une case afin d’accepter le Contrat de
          cession de droits (« Skeepers community agreement »).
        </p>
        <p>
          Skeepers se réserve le droit de contrôler les Contenus lorsque le
          Creator les publie sur le Site afin de vérifier leur conformité aux
          conditions fixées par le Client d’une part, et aux CGU Skeepers ainsi
          qu’au Contrat de cession de droits d’autre part.
        </p>
        <p>
          Dans l’hypothèse où le Contenu ne serait pas conforme, celui-ci
          pourrait ne pas être diffusé sur le Site. Par ailleurs, Skeepers
          pourra (i) notifier le Creator de cette non-conformité, et demander de
          remédier aux changements nécessaires pour que le Contenu soit conforme
          aux conditions fixées par la Client, aux CGU Skeepers et au Contrat de
          cession de droits, et/ou (ii) désactiver et/ou résilier le compte de
          le Creator.
        </p>
        <p>
          Concernant les avis consommateurs écrits, le Tester rédige son Contenu
          sur le Site puis une fois validé par Skeepers, le Creator copie le
          Contenu sur le site du Client dans un délai d’une heure suivant la
          validation.
        </p>

        <p className="tc-neutral900 ml-16">
          2/ Image du Client et des Produits
        </p>
        <p>
          La contrepartie des Services et en particulier la réception de
          Produits, est l’obligation pour le Creator de publier un Contenu, qui
          respecte les conditions, fixées par le Client, qu’il a acceptées. A
          défaut, Skeepers se réserve le droit de limiter ou de suspendre son
          accès à ses Services ou de supprimer ses Identifiants.
        </p>
        <p>
          Le Creator s’engage à respecter les Produits et l’image de la marque
          du Client. Ainsi, le Creator s’engage, en toute circonstance, à :
        </p>
        <ul className="paragraph-2">
          <li>
            Respecter les lois et règlements en vigueur applicables aux Clients
            et aux Produits et à ne pas porter atteinte aux droits de tiers ou à
            l’ordre public ;
          </li>
          <li>
            Ne pas revendre ou tirer profit, de quelque manière que ce soit, des
            Produits obtenus, pendant une durée minimum de 2 ans à compter de la
            réception ou de l’accès au Produit ;
          </li>
          <li>
            Ne pas recevoir de somme d'argent et/ou autre contrepartie pour
            évaluer les Produits (sauf mention contraire de la part de Skeepers)
            et ne pas contacter les Clients autrement que pour évaluer leurs
            Produits tel que prévu aux présentes ;
          </li>
          <li>
            Agir, communiquer, s’exprimer et rédiger en relation avec le Client
            et/ou les Produits avec discernement, courtoisie, et respect
            d’autrui dans les commentaires, appréciations, échanges qu’il pourra
            rédiger et qui seront diffusés sur les réseaux sociaux ;
          </li>
          <li>
            Collaborer avec Skeepers en lui fournissant toutes les informations
            nécessaires à la bonne exécution des Services ;
          </li>
          <li>
            Respecter les conditions prévues par le Client dans la description
            du Produit sur le Site ;
          </li>
          <li>
            A indiquer qu’il s’agit d’un contenu en partenariat avec une marque,
            dès lors que le Contenu ou la relation avec le Client entre dans les
            critères de la publicité digitale ou de la communication commerciale
            telle que définie par l’ARPP.
          </li>
        </ul>
        <p>
          En conséquence, le Creator s’interdit ainsi de diffuser, notamment, et
          sans que cette liste soit exhaustive :
        </p>
        <ul className="paragraph-2">
          <li>
            des Contenus pornographiques, obscènes, indécents, choquants ou
            inadaptés à un public familial, diffamatoires, injurieux, violents,
            racistes, xénophobes ou révisionnistes,
          </li>
          <li>des Contenus contrefaisants,</li>
          <li>des Contenus attentatoires à l’image d’un tiers,</li>
          <li>
            des Contenus mensongers, trompeurs ou proposant ou promouvant des
            activités illicites, frauduleuses ou trompeuses, des Contenus
            nuisibles aux systèmes informatiques de tiers (tels que virus, vers,
            chevaux de Troie, etc.), et
          </li>
          <li>
            plus généralement des Contenus susceptibles de porter atteinte aux
            droits de tiers, d’être préjudiciables à des tiers, ou d’engager la
            responsabilité de Skeepers ou du Client de quelque manière et sous
            quelque forme que ce soit. A cette fin, le Creator s’engage
            notamment à ne pas mentionner ou représenter de marque, logo, y
            compris sur des vêtements, autre que la/les marque(s) du/des
            Produit(s) envoyés par le Client. De même, le Creator s’engage à
            utiliser uniquement des musiques libres de droits dans son Contenu.
            Le Creator s’engage également à ne pas inclure ou montrer des
            enfants qui ne sont pas les siens ; ou tout adulte qui ne saurait ou
            qui n'aurait pas consenti à ce que la vidéo soit publiée ;
          </li>
        </ul>
        <p>
          Lorsque le Contenu ou la relation avec le Client entre dans les
          critères de la publicité digitale ou de la communication commerciale
          telle que définie par l’ARPP, ou lorsque que le Client l’exige, le
          Creator devra inclure au sein de chaque Contenu un avertissement clair
          et non-équivoque qu’il a reçu les Produits évalués gratuitement du
          Client via Skeepers, en incluant soit :
        </p>
        <ul className="paragraph-2">
          <li>
            Sur YouTube :
            <ul className="paragraph-2">
              <li>
                Au début de la vidéo : un discours oral facilement audible et
                compréhensible pour le Creator - en particulier qui soit
                suffisamment lent, et avec des mots qui seront compris de
                l’audience. Si la vidéo dure plus de dix minutes, le Creator
                devra répéter le discours à la fin de la vidéo ;
              </li>
              <li>
                Dans la section « A propos » : un texte explicatif clair et
                non-équivoque.
              </li>
            </ul>
          </li>
          <li>
            Sur Instagram :
            <ul className="paragraph-2">
              <li>
                Si le Contenu est une photo : un texte clair et non-équivoque
                disponible dans les trois premières lignes de la description de
                la photo.
              </li>
              <li>
                Si le Contenu est une story : un hashtag clair et non-équivoque
                diffusé dans chaque story.
              </li>
            </ul>
          </li>
          <li>
            Sur le site internet du Client : un texte clair et non-équivoque
            disponible dans les trois premières lignes du commentaire de le
            Creator relatif au produit du Client.
          </li>
          <li>
            Le Contenu doit refléter l’honnête opinion et l’expérience
            personnelle de le Creator, sur le fondement de son utilisation
            réelle du Produit. Le Creator s’engage à informer Skeepers
            immédiatement si son opinion venait à changer sur ledit Produit, et
            à retirer le Contenu correspondant immédiatement.
          </li>
          <li>
            Le Creator s’engage à ne pas faire d'affirmation scientifique ou de
            performance concernant le Produit (tel que « il diminue les rides !
            » ou « il m'hydrate toute la journée ! »). Le Creator doit se
            concentrer sur ce qu’il apprécie ou n’apprécie pas concernant le
            Produit, de son point de vue personnel.
          </li>
        </ul>
        <p>
          Tout manquement aux stipulations du présent article et plus
          généralement aux présentes CGU pourra entrainer, immédiatement et sans
          information préalable, la suppression ou suspension du compte de le
          Creator, nonobstant toute demande de dommages et intérêts de la part
          de Skeepers.
        </p>
        <p>
          En outre, Skeepers et/ou le Client peuvent également demander au
          Creator de retirer le Contenu concerné en cas de non-respect des
          règles et principes fixés ci-dessus, ce qu’il s’engage à faire sans
          délai à réception de la demande.
        </p>
        <p>
          Tout Produit reçu est strictement réservé à l’utilisation personnelle
          de le Creator. Le Creator s’interdit de le vendre. Le Creator pourra
          donner et/ou offrir à un tiers le Produit uniquement après les avoir
          testé et publié un Contenu conforme aux présentes CGU.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">
          7. Cession des droits d’utilisation du Contenu et autorisation de
          droit à l’image
        </p>
        <p>
          La publication du Contenu sur le Site par le Creator emportera
          concomitamment la conclusion par le Creator et Skeepers d’un Contrat
          de cession de droits sur le Contenu (« Community Agreement ») créé par
          le Creator ainsi que de la cession de ses droits à l’image accessible
          depuis le lien suivant :{' '}
          <a
            href="https://app.im.skeepers.io/community-agreement"
            target="_blank"
            rel="noopener noreferrer"
          >
            app.im.skeepers.io/community-agreement
          </a>
        </p>
        <p>
          En cas de refus de le Creator de signer ledit Contrat de cession de
          droits, celui-ci ne pourra pas publier son Contenu et devra ainsi
          renvoyer le Produit reçu à l’expéditeur.
        </p>
        <p>
          L’avis client écrit par le Creator s’apparente à un témoignage,
          toujours relatif à une expérience de consommation vécue et relève de
          la pure information des futurs consommateurs. Ainsi, Skeepers et ses
          partenaires peuvent librement utiliser, reproduire, publier, rendre
          disponible et traduire le contenu des avis clients dans le monde et
          dans quelque média et quelque support que ce soit.
        </p>
        <p>
          Le Creator ne voit, au jour de l’acceptation des présentes CGU, aucune
          réticence ou réserve aux dispositions du présent article. Il reconnait
          expressément que, s’il n’est pas disposé à signer le Contrat de
          cession de droits, il s’abstiendra de commander un Produit sur le Site
          car l’absence de cession des droits de propriété intellectuelle et
          droit à l’image attachés au Contenu constituerait une perte de temps
          pour Skeepers.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">
          8. Téléchargement des Contenus
        </p>
        <p>
          Le Client peut télécharger à titre non exclusif le Contenu concerné
          afin de le reproduire, de le représenter et de le sous-licencier, et
          notamment l’inclure sur tout support. Le Client bénéficie également de
          l’autorisation d’exploitation des images des personnes représentées
          dans ces Contenus identifiés par le Client lors de sa demande. Les
          droits précités sont cédés par le Creator à Skeepers via le Contrat de
          cession de droits précité. Skeepers concède lesdits droits au Client
          par la concession d’une licence non exclusive.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">9. Garantie</p>
        <p>
          Le Creator déclare et garantit que qu’il détient les Contenus (en ce
          compris les droits qui leur sont attachés, y compris les droits à
          l’image) en pleine propriété et/ou que le Creator dispose de tous les
          droits et autorisations nécessaires à l’exploitation et la diffusion
          du Contenu et qu’il n’existe aucun accord ou aucun droit qui
          pourraient venir faire obstacle à la présente garantie, à la cession
          ou à l’autorisation d’exploitation de l’image et des Contenus.
        </p>
        <p>
          Dans les cas où la loi n°2020-1266 du 19 octobre 2020 visant à
          encadrer l’exploitation commerciale de l’image d’enfants de moins de
          seize ans sur les plateformes en ligne et ses décrets d’application
          subséquents sont applicables, les représentants légaux des enfants
          mineurs de moins de seize ans sont tenus de demander l’agrément
          nécessaire auprès de l’autorité administrative compétente. Skeepers
          s’exonère de toute responsabilité en cas de défaut d’obtention dudit
          agrément par le ou les représentants légaux. Le Client peut, à tout
          moment, demander à vérifier l’agrément délivré aux représentants
          légaux qui devraient alors leur communiquer dès première demande. A
          cet égard, les formalités à respecter sont détaillées sur le site
          officiel de l’administration française.
        </p>
        <p>
          Le Creator garantit également que ces Contenus ne portent pas atteinte
          à l’ordre public, aux bonnes mœurs ou aux droits de tiers,
          n’enfreignent aucune disposition législative ou règlementaire et plus
          généralement, ne soient aucunement susceptibles de mettre en jeu la
          responsabilité civile ou pénale de Skeepers ou du Client.
        </p>
        <p>
          En conséquence de ce qui précède, le Creator garantit Skeepers et le
          Client contre toute action, réclamation, revendication, éviction
          quelconque, de la part de toute personne invoquant le non respect de
          la réglementation applicable, un droit de propriété intellectuelle,
          auquel les Contenus porteraient ou auraient porté atteinte, un acte de
          concurrence déloyale et/ou parasitaire, atteinte à l’ordre public, aux
          bonnes mœurs ou aux droits de tiers et notamment tendant à interdire
          ou restreindre leur utilisation et indemnisera en conséquence Skeepers
          et le Client de toutes les conséquences qui pourraient en résulter
          d’un manquement à la présente garantie (notamment toutes pertes,
          dommages et intérêts, dépenses et/ou frais y compris, notamment, les
          frais de justice et honoraires d’avocats).
        </p>
        <p>
          Skeepers ne monitore pas le Site mais se réserve le droit de retirer
          tout Contenu qui contreviendrait aux CGU ou qui ne respecterait pas la
          loi applicable, y compris qui violerait un droit de propriété
          intellectuelle, dès lors que Skeepers aurait eu connaissance de
          l'illicéité dudit Contenu. À cet effet, chaque Creator contactera
          Skeepers s'il estime qu'un Contenu viole l'un de ses droits et/ou la
          loi applicable et suivant les formalismes imposés par la loi
          concernant les demandes de retrait de contenu illicite. Après
          réception d'une demande de retrait valide au regard des lois
          applicables, Skeepers retirera promptement du Site le Contenu visé par
          cette demande.
        </p>
        <p>
          Le Creator doit évaluer et supporter les risques liés à l'utilisation
          de tout Contenu, notamment concernant l'exactitude, la complétude ou
          l'utilité d'un tel Contenu.
        </p>
        <p>
          Le Creator reconnait et accepte que toutes questions, commentaires,
          suggestions, idées, impressions ou autres informations à propos des
          Services (ci-après les "Propositions"), que le Creator fournit à
          Skeepers, ne sont pas confidentiels et que Skeepers est en droit
          d'utiliser et de diffuser, sans restriction, ces Propositions, à toute
          fin, commerciale ou autre, sans qu'aucune reconnaissance ou
          compensation quelle qu'elle soit ne soit due au Creator.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">10. Informatique et libertés</p>
        <p>
          Dans le cadre de ses activités et de la fourniture des Services,
          Skeepers traite des données à caractère personnel des Utilisateurs
          tels que ces termes sont définis par la réglementation applicable. Les
          différents traitements réalisés ainsi que les droits des Utilisateurs
          sont décrits dans la politique de confidentialité de Skeepers
          accessible sur son site depuis le lien suivant :{' '}
          <a
            href="https://app.im.skeepers.io/privacy"
            target="_blank"
            rel="noopener noreferrer"
          >
            app.im.skeepers.io/privacy
          </a>
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">11. Cookies</p>
        <p>
          Lors de la consultation du Site, des cookies sont susceptibles d’être
          déposés sur l’ordinateur, le mobile ou la tablette de le Creator.
          L’utilisation de certains cookies nécessite le consentement préalable
          de le Creator. Le Creator trouvera les informations propres aux
          cookies utilisés sur le présent site en cliquant ici :{' '}
          <a
            href="https://app.im.skeepers.io/privacy"
            target="_blank"
            rel="noopener noreferrer"
          >
            app.im.skeepers.io/privacy
          </a>
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">
          12. Propriété intellectuelle des éléments du Site
        </p>
        <p>
          L’ensemble des éléments édités sur le Site tels que les sons, les
          images, les photographies, les vidéos, les écrits, les animations, les
          programmes, la charte graphique, les utilitaires, les bases de
          données, les logiciels et les autres technologies sous-jacentes, est
          protégé par les dispositions du Code de propriété intellectuelle,
          appartient à Skeepers ou font l’objet d’une licence consentie à
          Skeepers. Tout signe distinctif figurant sur le Site, notamment les
          dénominations sociales, les marques et les logotypes sont des marques
          détenues par Skeepers ou par des tiers ou partenaires notamment les
          Clients dont les offres sont présentées sur le Site. Toute
          reproduction totale ou partielle, modification ou utilisation de ces
          marques, illustrations, images et logotypes, pour quelque motif et sur
          quelque support que ce soit, sans accord exprès et préalable du
          titularité des droits est strictement interdite et constituerait une
          contrefaçon sanctionné par le Code de la propriété intellectuelle. Le
          Creator s’engage à une utilisation du Site et de son contenu dans un
          cadre strictement privé. Une utilisation à des fins commerciales est
          strictement interdite. Le Creator sollicite l’autorisation préalable
          de Skeepers pour toute reproduction, publication, copie des différents
          contenus.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">13. Renvois et liens</p>
        <p>
          Des liens hypertextes sont mis à disposition de le Creator renvoyant
          vers des sites partenaires ou des sites tiers. Dans la mesure où
          Skeepers ne peut contrôler ces sites, Skeepers se dégage de toute
          responsabilité quant aux informations contenues sur ces sites.
          Skeepers ne saurait être responsable notamment des modifications ou
          mises à jour de ces sites ou d’un quelconque dysfonctionnement de
          ceux-ci. Skeepers ne peut en aucun cas être tenue pour responsable des
          dommages directs ou indirects liés à la navigation ou au
          téléchargement sur des liens hypertextes publiés sur le Site internet.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">14. Responsabilité</p>
        <p>
          L’utilisation du Site implique la connaissance et l’acceptation par le
          Creator des caractéristiques et des limites de l’Internet et des
          technologies qui y sont liées. Skeepers ne saurait être tenue pour
          responsable de quelque dommage que ce soit provenant d’une connexion
          au Site que le Creator effectue sous sa seule responsabilité. A ce
          titre, Skeepers décline toute responsabilité notamment en cas de
          mauvaise utilisation ou d’incident lié à l’utilisation de l’appareil
          pour se connecter au Site, de l’accès à Internet, de la maintenance ou
          du dysfonctionnement des serveurs, de la ligne téléphonique ou de
          toute autre connexion technique, et de l’envoi des formulaires à une
          adresse erronée ou incomplète, d’erreurs informatiques quelconques ou
          de défauts constatés sur le Site. Par ailleurs, Skeepers s’efforce de
          fournir sur le site des informations précises et à jour. Toutefois,
          Skeepers ne saurait en aucun être reconnu responsable des
          inexactitudes ou omissions sur son Site.
        </p>
        <p>
          Skeepers ne sera responsable que des dommages directs résultant de
          l’utilisation du Site et en tout état de cause, l’accès aux Service
          étant gratuit, sa responsabilité est plafonnée à la somme de 100 €.
          Par conséquent, Skeepers décline toute responsabilité et ne saurait
          être tenue pour responsable de quelque dommage indirect que ce soit,
          provenant d’une cause extérieure à son Site, comme, sans que la liste
          soit exhaustive : provenant de l’utilisation ou de la réception d’un
          Produit reçu par le Creator, provenant ou en rapport avec un Contenu
          créé par le Creator, provenant ou en rapport avec la mise en relation
          entre le Client et le Creator, etc.
        </p>
        <p>
          Skeepers rappelle aux Creators qu’ils sont susceptibles d’avoir des
          obligations fiscales (TVA, impôts etc.) et sociales (URSSAF etc.)
          relatives à leurs activités dont ils ont l’entière responsabilité. Les
          démarches à réaliser pour se conformer aux exigences législatives et
          règlementaires à ce titre, qui sont fonctions de différents critères
          selon le cas particulier du Creator, sont précisées sur les sites
          internet suivants :
        </p>
        <ul className="paragraph-2">
          <li>
            pour les obligations fiscales :{' '}
            <a
              href="https://impots.gouv.fr"
              target="_blank"
              rel="noopener noreferrer"
            >
              impots.gouv.fr
            </a>{' '}
            et
          </li>
          <li>
            pour les obligations sociales :{' '}
            <a
              href="https://ameli.fr"
              target="_blank"
              rel="noopener noreferrer"
            >
              ameli.fr
            </a>
            .
          </li>
        </ul>
        <p>
          Outre les garanties prévues aux présentes, le Creator garantit la
          société Skeepers contre toutes plaintes, réclamations, actions et/ou
          revendications quelconques que Skeepers pourrait subir du fait de la
          violation, par le Creator de l’une quelconque de ses obligations ou
          garanties aux termes des présentes conditions générales. Il s’engage à
          indemniser Skeepers de tout préjudice qu’elle subirait et à lui payer
          tous les frais, charges et/ou condamnations qu’elle pourrait avoir à
          supporter de ce fait.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">
          15. Acceptation des conditions d’Utilisation des Réseaux Sociaux
        </p>
        <p>
          Skeepers utilise l'API de Youtube notamment pour authentifier et lier
          la chaine Youtube de le Creator à son profil sur le Site. En
          conséquence, en utilisant le Site, le Creator accepte expressément les
          conditions d'utilisation de Youtube disponible à l'adresse URL
          suivante :{' '}
          <a
            href="https://www.youtube.com/t/terms"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://www.youtube.com/t/terms
          </a>
        </p>
        <p>
          De la même manière, le Creator s’engage à accepter et à respecter les
          conditions d’utilisation de chaque Réseau Social qu’il utilise pour
          publier du Contenu.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">16. Dispositions diverses</p>
        <p>
          Skeepers se réserve le droit de modifier à tout moment les présentes
          CGU. Un message sous forme de pop-up sur le Site informera les
          Creators de la mise à jour des CGU. Il est recommandé au Creator de
          prendre connaissance régulièrement des CGU.
        </p>
        <p>
          La nullité de tout ou partie de l’une des dispositions des présentes
          CGU ne saurait entrainer la nullité des autres dispositions.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">17. Adhésion</p>
        <p>
          L’acceptation des présentes conditions générales est matérialisée par
          une case à cocher dans le formulaire d’inscription proposé au Creator
          lors de son inscription sur le Site avec un lien URL vers les CGU.
          Cette acceptation est sans réserve. En outre, les CGU sont disponibles
          à tout moment sur le Site.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">18. Droit applicable</p>
        <p>
          Le Site et les CGU sont soumis au droit français. Tout litige se
          rapportant à l’interprétation ou l’exécution des présentes CGU sera
          soumis à la compétence des tribunaux de Marseille compétents.
        </p>
      </div>
    </>
  )
}

export default ConditionsForContributorsFR
